// extracted by mini-css-extract-plugin
export default {"select-language":"chooselanguage_select-language__XxOkt"};